import dayjs from 'dayjs';

export const formatValue = (value, type) => {
  if (Array.isArray(value)) {
    return value.map((item) => formatValue(item, type)).join(', ');
  }

  if (type === 'date') {
    return dayjs(value).format('YYYY-MM-DD');
  }

  if (type === 'dateTime') {
    return dayjs(value).format('YYYY-MM-DD HH:mm');
  }

  return value;
};
